import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { FormOfPaymentIssuerSort, FormOfPaymentIssuerUpdateSortSequence } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentIssuerReferenceService } from "src/app/core/services/system-services/form-of-payment-issuer-reference.service";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentIssuerSortService {

    private _formOfPaymentIssuers$ = new BehaviorSubject<FormOfPaymentIssuerSort[]>([])
    private _callSort$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()
    private _updateSort$ = new Subject()

    get formOfPaymentIssuers$() {
        return this._formOfPaymentIssuers$.asObservable()
    }
    get callSort$() {
        return this._callSort$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }
    get updateSort$() {
        return this._updateSort$.asObservable()
    }

    constructor(private formOfPaymentIssuerReference: FormOfPaymentIssuerReferenceService
    ) {
    }

    getFormOfPaymentIssuersSort(): Observable<FormOfPaymentIssuerSort[]> {
        return this.formOfPaymentIssuerReference.getSort()
            .pipe(
                tap(response => this._formOfPaymentIssuers$.next(response))
            )
    }

    updateSortSequence(items: FormOfPaymentIssuerUpdateSortSequence[]): Observable<never> {
        return this.formOfPaymentIssuerReference.updateSortSequence(items)
    }

    clearSort() {
        this._formOfPaymentIssuers$.next([])
    }
    callSort() {
        this._callSort$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }
    updateSort() {
        this._updateSort$.next()
    }
}
